import {
    IonBackButton, IonButtons, IonLabel,
    IonContent,
    IonHeader,
    IonPage,
    IonProgressBar,
    IonTitle,
    IonToolbar,
    IonIcon, IonButton
} from '@ionic/react';
import {IonList, IonItem} from '@ionic/react';
import {isPlatform} from '@ionic/react';
import React from "react";
import useUX from "../ux/UX";
import {warningOutline} from "ionicons/icons";
import BlindControlSlider from "../components/BlindControlSlider";
import styles from "./ControlBlinds.module.css";
import {useBlindsQuery, useSetAllBlindsPositionMutation} from "../query/blindsQuery";
import {useAlarmStateQuery} from "../query/buildingStateQuery";
import {useGatewayConnectionStateQuery} from "../query/gatewayConnectionStateQuery";

const ControlBlinds: React.FC = () => {
    const blindsQuery = useBlindsQuery();
    const blinds = Object.values(blindsQuery.data ?? {});
    const setAllBlindsPositionMutation = useSetAllBlindsPositionMutation();
    const {data: alarmState = ''} = useAlarmStateQuery();
    const {isConnecting} = useGatewayConnectionStateQuery();
    const {presentResult} = useUX();

    async function requestAllBlindsPosition(position: number) {
        await presentResult(async () => {
            await setAllBlindsPositionMutation.mutateAsync(position);
        }, `Setting all blinds to ${position}%`);
    }

    return (
        <IonPage>
            <IonHeader translucent={isPlatform('capacitor')} collapse="fade">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/control"/>
                    </IonButtons>
                    <IonTitle>All Blinds</IonTitle>
                    <IonButtons slot="primary">
                        <IonButton onClick={() => requestAllBlindsPosition(0)}>
                            <IonIcon slot="icon-only" src="/assets/icon/blinds-up.svg"/>
                        </IonButton>
                        <IonButton onClick={() => requestAllBlindsPosition(100)}>
                            <IonIcon slot="icon-only" src="/assets/icon/blinds-down.svg"/>
                        </IonButton>
                    </IonButtons>
                    {!!(isConnecting || blindsQuery.isPending || setAllBlindsPositionMutation.isPending)
                        && <IonProgressBar type="indeterminate"/>}
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
                {alarmState === 'ARMED' && (
                    <IonItem color="danger" routerLink="/access/alarm" button detail={true}>
                        <IonIcon slot="start" icon={warningOutline}/>
                        <IonLabel>
                            <h2>The alarm is set</h2>
                            <p>Unset it before operating blinds.</p>
                        </IonLabel>
                    </IonItem>)}
                <IonList>
                    {blinds.map((blind: any) => (
                        <IonItem className={styles.item} key={blind.mac}>
                            <IonLabel position="stacked">{blind.name || blind.mac}</IonLabel>
                            <BlindControlSlider key={blind.mac} blind={blind}/>
                        </IonItem>
                    ))}
                </IonList>
            </IonContent>
        </IonPage>
    );
};

export default ControlBlinds;
